import type { ReactElement } from 'react';
import { Button } from '@studio/design-system/button';
import { useUserInvitePrompt } from './hooks.js';
import type { Room } from '@studio/models/room';
import type { T_Maybe } from '@tryiris-ai/js-types';
import { useAnalytics, EVENT_CATEGORIES, EVENT_NAMES } from '#~/analytics/index.js';

export const InviteButton = ({ roomId }: { roomId?: T_Maybe<Room['id']> }): ReactElement | null => {
  const dialog = useUserInvitePrompt(roomId);
  const { track } = useAnalytics();

  const showInviteUserPrompt = () => {
    // Track pressing the share button
    track(EVENT_NAMES.PRESS_SHARE_BUTTON, EVENT_CATEGORIES.SHARING, {
      ...(roomId && { studioId: roomId })
    });
    dialog.open();
  };

  return (
    <Button className='ml-8 px-8' disabled={!dialog.canCreateInvite} onClick={showInviteUserPrompt}>
      Share
    </Button>
  );
};
